import { render } from "./CommunicationContainer.vue?vue&type=template&id=ccaeb3d4&scoped=true&ts=true"
import script from "./CommunicationContainer.vue?vue&type=script&lang=ts"
export * from "./CommunicationContainer.vue?vue&type=script&lang=ts"

import "./CommunicationContainer.vue?vue&type=style&index=0&id=ccaeb3d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccaeb3d4"]])

export default __exports__